module.exports = __webpack_public_path__ + "static/media/menubar.f7153505.svg";